import { createApi } from '@reduxjs/toolkit/query/react';
import { List } from 'immutable';
import Pain from 'models/ValueProposition/Pain';
import { axiosBaseQuery } from 'services/api';
import { byId } from 'store/utils/sortFunctions';

const PAIN_TAG = 'ValuePropositionPain';

// API slice for Value Proposition / Pains
export const valuePropositionPainsApi = createApi({
  reducerPath: 'valuePropositionPainsApi',
  baseQuery: axiosBaseQuery(),
  tagTypes: [PAIN_TAG],
  endpoints: builder => ({
    // Returns undefined during loading or a List of Pain instances sorted by id
    listPains: builder.query({
      query: ({ project, product, segment }) => ({
        url: `/api/projects/${project}/products/${product}/segments/${segment}/pains/`,
      }),
      transformResponse: response =>
        List(Array.isArray(response) ? response.map(pain => new Pain(pain)).sort(byId) : []),
      providesTags: [PAIN_TAG],
    }),
    fetchPain: builder.query({
      query: ({ project, product, segment, id }) => ({
        url: `/api/projects/${project}/products/${product}/segments/${segment}/pains/${id}/`,
      }),
      transformResponse: response => new Pain(response),
    }),
    createPain: builder.mutation({
      query: ({ project, product, segment, ...data }) => ({
        url: `/api/projects/${project}/products/${product}/segments/${segment}/pains/`,
        method: 'POST',
        data,
      }),
      invalidatesTags: [PAIN_TAG],
      transformResponse: response => new Pain(response),
    }),
    updatePain: builder.mutation({
      query: ({ project, product, segment, painId, ...data }) => ({
        url: `/api/projects/${project}/products/${product}/segments/${segment}/pains/${painId}/`,
        method: 'PATCH',
        data,
      }),
      invalidatesTags: [PAIN_TAG],
      transformResponse: response => new Pain(response),
    }),
    deletePain: builder.mutation({
      query: ({ project, product, segment, painId }) => ({
        url: `/api/projects/${project}/products/${product}/segments/${segment}/pains/${painId}/`,
        method: 'DELETE',
      }),
      invalidatesTags: [PAIN_TAG],
    }),
  }),
});

export const {
  useListPainsQuery,
  useFetchPainQuery,
  useCreatePainMutation,
  useUpdatePainMutation,
  useDeletePainMutation,
} = valuePropositionPainsApi;
